import type { Editor } from "@tiptap/core";

/**
 * Collects manuscript comment annotation IDs from the current TipTap/ProseMirror selection.
 * Annotation marks may list multiple space-separated ids when ranges overlap.
 *
 * Pass `range` to collect from an explicit range instead of the live selection
 * (e.g. the persisted fake-selection highlight while the editor is blurred).
 */
export function collectAnnotationIdsFromTipTapSelection(editor: Editor, range?: { from: number; to: number } | null): string[] {
  const { state } = editor;
  const from = range?.from ?? state.selection.from;
  const to = range?.to ?? state.selection.to;
  if (from >= to) return [];

  const ids = new Set<string>();
  state.doc.nodesBetween(from, to, (node) => {
    if (!node.isText) return;
    for (const mark of node.marks) {
      if (mark.type.name !== "annotation") continue;
      const raw = mark.attrs?.annotationId;
      if (raw == null) continue;
      for (const id of String(raw).trim().split(/\s+/)) {
        if (id) ids.add(id);
      }
    }
  });

  return [...ids];
}
